import React from "react";
import Images from "./components/Images";
import Videos from "./components/Videos";

export const Media = () => {
  return (
    <div className="media-page">
      <div className="container">
        <Images />
        <Videos />
      </div>
    </div>
  );
};
